import React from 'react'
import Box from '@mui/material/Box'
import TextField from '@mui/material/TextField'
import { Field, useFormikContext } from 'formik'
import Typography from '@mui/material/Typography'
import { BaseTextField } from '@user/components/Formik'

import { ImportUtilityModel } from '../../typings'

const maxNoteLines = 10
const maxLength = 5000

export function Note() {
  const {
    values: { note },
  } = useFormikContext<ImportUtilityModel>()
  return (
    <Box mb={3.2}>
      <Typography variant="h7">Note (Optional)</Typography>
      <Typography mb={1.6} variant="body1">
        You can choose to add a note that will be added to each record imported.
      </Typography>
      <Field
        name={'note'}
        as={TextField}
        autoComplete="off"
        component={BaseTextField}
        error={false}
        fullWidth
        helperText={`${note?.length}/5,000`}
        inputProps={{
          maxLength: maxLength,
        }}
        label="Add Note"
        multiline
        required={false}
        minRows={5.5}
        type="text"
        variant="outlined"
        {...(maxNoteLines && { maxRows: maxNoteLines })}
      />
    </Box>
  )
}
